"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_API_URL = void 0;
exports.STORE_API_URL = 'https://store.xsolla.com/api/v2';
